import { useState } from 'react';
import { Box, Typography, Grid, FormControlLabel, Button } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import { useForm } from 'react-hook-form';
import { IAssociationMember } from '../../../Types/UpdateInfotypes/UpdateCompanyInfoStateTypes';
import { useAuthContext } from '../../../Context/AuthContext/AuthContext';
import { useCompanyBusinessLicenseUpdate } from '../../../rest/useCompanyInfo';
import FileValidation from '../../../Components/FileValidation/FileValidation';

const AddBusinessLicenseInfo = () => {
  const { user } = useAuthContext();
  const {
    register,
    handleSubmit,
    clearErrors,
    setError,
    formState: { errors },
  } = useForm();
  const { isLoading, mutate } = useCompanyBusinessLicenseUpdate();
  const [businessLicense, setBusinessLicense] = useState<any>({
    hajj_license: 0,
    umrah_license: 0,
    recruting_license: 0,
    outbound: 0,
    inbound: 0,
  });
  const [associationMember, setAssociationMember] =
    useState<IAssociationMember>({
      baira_membership: 0,
      haab_membership: 0,
      iata_membership: 0,
      toab_membership: 0,
      tdab_membership: 0,
    });
  const onSubmit = async (inputsData: any) => {
    inputsData = { ...inputsData, ...businessLicense, ...associationMember };
    const formData = new FormData();
    Object.keys(inputsData).forEach((key) => {
      if (typeof inputsData[key] === 'object') {
        formData.append(key, inputsData[key][0]);
      } else {
        formData.append(key, inputsData[key]);
      }
    });
    mutate({ input: formData });
  };

  return (
    <Box component='form' onSubmit={handleSubmit(onSubmit)} p={2}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Typography variant='h6' gutterBottom>
            Other business license ( please tick mark in box )
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <FormControlLabel
                control={<Checkbox />}
                label='Hajj'
                onClick={(e: any) => {
                  if (e.target.checked) {
                    setBusinessLicense({
                      ...businessLicense,
                      hajj_license: 1,
                    });
                  } else {
                    setBusinessLicense({
                      ...businessLicense,
                      hajj_license: 0,
                    });
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControlLabel
                control={<Checkbox />}
                label='Umrah'
                onClick={(e: any) => {
                  if (e.target.checked) {
                    setBusinessLicense({
                      ...businessLicense,
                      umrah_license: 1,
                    });
                  } else {
                    setBusinessLicense({
                      ...businessLicense,
                      umrah_license: 0,
                    });
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControlLabel
                control={<Checkbox />}
                label='Recruiting'
                onClick={(e: any) => {
                  if (e.target.checked) {
                    setBusinessLicense({
                      ...businessLicense,
                      recruting_license: 1,
                    });
                  } else {
                    setBusinessLicense({
                      ...businessLicense,
                      recruting_license: 0,
                    });
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControlLabel
                control={<Checkbox />}
                label='BAIRA'
                onClick={(e: any) => {
                  if (e.target.checked) {
                    setAssociationMember({
                      ...associationMember,
                      baira_membership: 1,
                    });
                  } else {
                    setAssociationMember({
                      ...associationMember,
                      baira_membership: 0,
                    });
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box>
                <FormControlLabel
                  control={<Checkbox />}
                  label='HAAB'
                  onClick={(e: any) => {
                    if (e.target.checked) {
                      setAssociationMember({
                        ...associationMember,
                        haab_membership: 1,
                      });
                    } else {
                      setAssociationMember({
                        ...associationMember,
                        haab_membership: 0,
                      });
                    }
                  }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box>
                <FormControlLabel
                  control={<Checkbox />}
                  label='IATA'
                  onClick={(e: any) => {
                    if (e.target.checked) {
                      setAssociationMember({
                        ...associationMember,
                        iata_membership: 1,
                      });
                    } else {
                      setAssociationMember({
                        ...associationMember,
                        iata_membership: 0,
                      });
                    }
                  }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box>
                <FormControlLabel
                  control={<Checkbox />}
                  label='TOAB'
                  onClick={(e: any) => {
                    if (e.target.checked) {
                      setAssociationMember({
                        ...associationMember,
                        toab_membership: 1,
                      });
                    } else {
                      setAssociationMember({
                        ...associationMember,
                        toab_membership: 0,
                      });
                    }
                  }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box sx={{ pl: { xs: 12, md: 0 } }}>
                <FormControlLabel
                  control={<Checkbox />}
                  label='TDAB'
                  onClick={(e: any) => {
                    if (e.target.checked) {
                      setAssociationMember({
                        ...associationMember,
                        tdab_membership: 1,
                      });
                    } else {
                      setAssociationMember({
                        ...associationMember,
                        tdab_membership: 0,
                      });
                    }
                  }}
                />
              </Box>
            </Grid>

            {/* Add more items here as needed */}
          </Grid>

          {/*---------------------- file------------------------ */}
          <Box>
            {businessLicense.hajj_license ? (
              <Box>
                <FileValidation
                  mt={'0'}
                  isRequired
                  register={register}
                  clearErrors={clearErrors}
                  setError={setError}
                  errors={errors}
                  label='Member organization Hajj license ( max size 5mb )'
                  fieldName={`hajj_license_file`}
                />
              </Box>
            ) : (
              ''
            )}
            {businessLicense.umrah_license ? (
              <Box>
                <FileValidation
                  mt={'0'}
                  isRequired
                  register={register}
                  clearErrors={clearErrors}
                  setError={setError}
                  errors={errors}
                  label='Member organization Umrah license ( max size 5mb )'
                  fieldName={`umrah_license_file`}
                />
              </Box>
            ) : (
              ''
            )}
            {businessLicense.recruting_license ? (
              <Box>
                <FileValidation
                  mt={'0'}
                  isRequired
                  register={register}
                  clearErrors={clearErrors}
                  setError={setError}
                  errors={errors}
                  label='Member organization Recruiting license ( max size 5mb )'
                  fieldName={`recruting_license_file`}
                />
              </Box>
            ) : (
              ''
            )}
          </Box>
          <Box>
            {associationMember.baira_membership ? (
              <Box>
                <FileValidation
                  mt={'0'}
                  isRequired
                  register={register}
                  clearErrors={clearErrors}
                  setError={setError}
                  errors={errors}
                  label='Upload association BAIRA document ( max size 5mb )'
                  fieldName={`baira_membership_file`}
                />
              </Box>
            ) : (
              ''
            )}
            {associationMember.haab_membership ? (
              <Box>
                <FileValidation
                  mt={'0'}
                  isRequired
                  register={register}
                  clearErrors={clearErrors}
                  setError={setError}
                  errors={errors}
                  label='Upload association HAAB document ( max size 5mb )'
                  fieldName={`haab_membership_file`}
                />
              </Box>
            ) : (
              ''
            )}
          </Box>
          <Box>
            {associationMember.iata_membership ? (
              <Box>
                <FileValidation
                  mt={'0'}
                  isRequired
                  register={register}
                  clearErrors={clearErrors}
                  setError={setError}
                  errors={errors}
                  label='Upload association IATA document ( max size 5mb )'
                  fieldName={`iata_membership_file`}
                />
              </Box>
            ) : (
              ''
            )}
            {associationMember.toab_membership ? (
              <Box>
                <FileValidation
                  mt={'0'}
                  isRequired
                  register={register}
                  clearErrors={clearErrors}
                  setError={setError}
                  errors={errors}
                  label='Upload association TOAB document ( max size 5mb )'
                  fieldName={`toab_membership_file`}
                />
              </Box>
            ) : (
              ''
            )}

            {associationMember.tdab_membership ? (
              <Box>
                <FileValidation
                  mt={'0'}
                  isRequired
                  register={register}
                  clearErrors={clearErrors}
                  setError={setError}
                  errors={errors}
                  label='Upload association TDAB document ( max size 5mb )'
                  fieldName={`tdab_membership_file`}
                />
              </Box>
            ) : (
              ''
            )}
          </Box>
        </Grid>

        <Grid item xs={12} md={6}>
          <Typography variant='h6' gutterBottom>
            Involved in tourism activities ( please tick mark in box )
          </Typography>
          <Box
            sx={{
              display: 'flex',
              gap: 15,
              pl: { xs: 7, md: 0 },

              textAlign: 'center',
              alignItems: 'center',
            }}
          >
            <Box>
              <FormControlLabel
                control={<Checkbox />}
                label=' Inbound'
                onClick={(e: any) => {
                  if (e.target.checked) {
                    setBusinessLicense({
                      ...businessLicense,
                      inbound: 1,
                    });
                  } else {
                    setBusinessLicense({
                      ...businessLicense,
                      inbound: 0,
                    });
                  }
                }}
              />
            </Box>
            <Box>
              <FormControlLabel
                control={<Checkbox />}
                label='Outbound'
                onClick={(e: any) => {
                  if (e.target.checked) {
                    setBusinessLicense({
                      ...businessLicense,
                      outbound: 1,
                    });
                  } else {
                    setBusinessLicense({
                      ...businessLicense,
                      outbound: 0,
                    });
                  }
                }}
              />
            </Box>
          </Box>
        </Grid>
      </Grid>

      {!user.is_applied ? (
        <Box sx={{ mt: 2, textAlign: 'end', mb: 1 }}>
          {isLoading ? (
            <Button disabled variant='contained' disableElevation>
              Loading...
            </Button>
          ) : (
            <Button type='submit' variant='contained' disableElevation>
              Save
            </Button>
          )}
        </Box>
      ) : (
        ''
      )}
    </Box>
  );
};

export default AddBusinessLicenseInfo;
